module.exports = __webpack_public_path__ + "img/avatar1.8e657a05.png";